import { defineStore } from "pinia";
import { socket } from "@/user.socket";
import { useAuthStore } from "@/stores/auth";

export const useChatStore = defineStore('chat', {
  state: () => ({
    messages: [],
  }),

  getters: {
    getMessages: state => state.messages,
    //Number of unread messages, driven by the user's unrm field
    unreadCount: () => {
      const authStore = useAuthStore();
      return authStore.user?.unrm || 0;
    }
  },

  actions: {
    // Fetch all messages from server
    fetchMessages() {
      socket.emit('clt:get-messages');
    },

    // Send a new message
    setMessage(payload) {
      socket.emit('clt:send-message', payload);
    },

    // Listen for incoming socket events
    bindSocketMessages() {
      const authStore = useAuthStore();

      socket.on('clt:send-message', ({ ok, data }) => {
        if (ok) this.handleIncomingMessage(data, authStore);
      });

      socket.on('clt:get-message', ({ ok, data }) => {
        if (ok) this.handleIncomingMessage(data, authStore);
      });

      socket.on('clt:get-messages', ({ ok, data }) => {
        if (ok) {
          this.messages = data.map(msg => ({ ...msg, isrc: true }));
          authStore.user.unrm = authStore.user.unrm || authStore.user.unrm;
        }
      });

      //reset unread count
      socket.on('clt:messages-marked-read', () => {
        authStore.user.unrm = 0;
      });
    },

    // Handle any incoming message
    handleIncomingMessage(data, authStore) {
      this.messages.unshift(data);
      // If the message is from operator
      if (data.opid) {
        authStore.user.unrm = (authStore.user.unrm || 0) + 1;
      }
    },

    // Tell backend to mark all messages as read 
    markAllRead() {
      socket.emit('clt:mark-all-messages-as-read');
      // reset unread count locally
      const authStore = useAuthStore();
      authStore.user.unrm = 0;
    },
  },
});
